import React, { useState, useEffect } from "react";
import Select from "react-select-virtualized";

const normalizeMultiValue = (selected) => {
    if (!selected) return [];
    return Array.isArray(selected) ? selected : [selected];
};

const getOptionValue = (option) => `${option?.value}`;

const mergeMultiValue = (selected, currentSelected) => {
    if (!selected) return [];
    if (Array.isArray(selected)) return selected;

    const current = normalizeMultiValue(currentSelected);
    const selectedValue = getOptionValue(selected);
    const isSelected = current.some((item) => getOptionValue(item) === selectedValue);

    if (isSelected) return current.filter((item) => getOptionValue(item) !== selectedValue);
    return [...current, selected];
};

const SelectBox = ({ options, name, onChange, value, className = "", placeholder = "", isMulti = false, ...rest }) => {
    const [optionSelected, setSelectedOptions] = useState([]);

    useEffect(() => {
        if (isMulti) {
            const values = Array.isArray(value) ? value.map(String) : `${value || ""}`.split(",").filter(Boolean);
            setSelectedOptions(options.filter((o) => values.includes(`${o.value}`)));
            return;
        }
        setSelectedOptions(options.find((o) => `${o.value}` === `${value}`));
    }, [options, value, isMulti]);

    const handleChange = (selected) => {
        const normalizedSelected = isMulti ? mergeMultiValue(selected, optionSelected) : selected;
        onChange?.({ name, value: isMulti ? normalizedSelected.map((item) => item.value) : selected?.value });
        setSelectedOptions(normalizedSelected);
    };

    return (
        <Select
            options={options}
            isLoading={!options}
            isMulti={isMulti}
            closeMenuOnSelect={!isMulti}
            onChange={handleChange}
            value={optionSelected}
            className={className || "cotik-select-virtual"}
            theme={(theme) => ({
                ...theme,
                spacing: {
                    ...theme.spacing,
                    controlHeight: "100%",
                    controlWidth: "200px",
                },
            })}
            placeholder={placeholder}
            {...rest}
            styles={{
                // container: (base) => ({
                //     ...base,
                //     display: "inline-block",
                //     minWidth: 200
                // }),
                // control: (base) => ({
                //     ...base,
                //     width: "max-content",
                //     minWidth: 200
                // }),
                menu: (base) => ({
                    ...base,
                    width: 450,
                }),
                option: (base) => ({
                    ...base,
                    whiteSpace: "nowrap"
                })
            }}
        />
    );
};

export default SelectBox;
